import {
	APPLICATION_TYPE_OPTIONS,
	EMAIL_OPTION,
	SAVED_RESULT_OPTION,
} from "../../data/applicationTypes";
import { PumpSizingFormData } from "../../types/types";
import { getGpmDisplayValue } from "./gpmHelpers";
import { getTdhDisplayValue } from "./tdhHelpers";

export function parseNumericValue(value: string, fallback = 0): number {
	const trimmed = value.trim();
	if (trimmed === "") {
		return fallback;
	}

	const parsed = Number.parseFloat(trimmed);
	return Number.isNaN(parsed) ? fallback : parsed;
}

export function formatNumericValue(value: number): string {
	if (!Number.isFinite(value) || value <= 0) {
		return "";
	}

	return Number.isInteger(value) ? String(value) : value.toFixed(2);
}

const applicationLabels = [
	...APPLICATION_TYPE_OPTIONS,
	EMAIL_OPTION,
	SAVED_RESULT_OPTION,
].reduce(
	(acc, option) => {
		acc[option.id] = option.sidebarLabel ?? option.title;
		return acc;
	},
	{} as Record<string, string>,
);

export function getStepSelectedValue(
	stepId: number,
	formData: PumpSizingFormData,
): string | undefined {
	switch (stepId) {
		case 1:
			return formData.applicationType
				? applicationLabels[formData.applicationType]
				: undefined;
		case 2:
			return getGpmDisplayValue(formData) || undefined;
		case 3:
			return getTdhDisplayValue(formData) || undefined;
		default:
			return undefined;
	}
}